import { useContext, useMemo, useState } from "react";
import IconButton from "../Buttons/IconButton";
import FilterModal from "./FilterModal";
import { FilterContext } from "./FilterContext";
import styled from "styled-components";

export default function Filters() {
  const filters = useContext(FilterContext);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const filtersActive = useMemo(
    () =>
      Boolean(
        filters?.members?.length ||
          filters?.years?.length ||
          filters?.projects?.length ||
          filters?.plannedDates?.length
      ),
    [filters]
  );
  return (
    <FiltersContainer>
      <IconButton
        icon="filter"
        tooltip="Open filter opties"
        onClick={() => setShowFilters(true)}
        size="large"
        iconColor={filtersActive ? "rgb(0, 117, 188)" : undefined}
        indicator={filtersActive}
      />
      {showFilters ? (
        <FilterModal onDismiss={() => setShowFilters(false)} />
      ) : null}
    </FiltersContainer>
  );
}

const FiltersContainer = styled.div`
  margin-right: 18px;
`;
